export default __webpack_public_path__ + "static/media/SOA_rilascio.7f64dafe.jpg";